import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState } from "react";
import { useTranslations } from "next-intl";
import { analytics } from "@silvertours/front-entities";
import { http } from "@silvertours/front-shared";
import { NewsletterSignup } from "./NewsletterSignup";
import { NewsletterSignupSuccess } from "./NewsletterSignupSuccess";
import { useNewsletter } from "./useNewsletter";
var NewsletterRegistration = function(param) {
    var type = param.type;
    var formatApiUrl = useNewsletter().formatApiUrl;
    var ref = useState(false), success = ref[0], setSuccess = ref[1];
    var isIndexType = type === "index";
    var t = useTranslations("features.newsletterRegistrationLegacy.newsletterRegistration");
    var trackRegistration = function() {
        if (type === "index") {
            analytics.gtm.trackNewsletterRegistrationIndex();
        } else {
            analytics.gtm.trackNewsletterRegistration();
        }
    };
    var onSubmit = function() {
        var _ref = _async_to_generator(function(email) {
            var sourceParam, axiosError;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        sourceParam = {
                            index: t("sourceParam.index"),
                            landing: t("sourceParam.landing")
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            http.axiosInstance.post(formatApiUrl("v1/newsletter/subscribe"), {
                                email: email,
                                sourceParam: sourceParam[type]
                            })
                        ];
                    case 2:
                        _state.sent();
                        setSuccess(true);
                        trackRegistration();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        axiosError = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(email) {
            return _ref.apply(this, arguments);
        };
    }();
    return success ? /*#__PURE__*/ _jsx(NewsletterSignupSuccess, {
        showTitle: isIndexType
    }) : /*#__PURE__*/ _jsx(NewsletterSignup, {
        showImage: isIndexType,
        showTitle: isIndexType,
        showHeadline: isIndexType,
        onSubmit: onSubmit
    });
};
export { NewsletterRegistration };
